import NauiDateRange from './naui/atoms/NauiDateRange.svelte';
import ReqGeneral from './lic/ReqGeneral.svelte';
import ReqFechas from './lic/ReqFechas.svelte';
import ReqItems from './lic/ReqItems.svelte';
import ReqAsignacion from './lic/ReqAsignacion.svelte';
import ReqCodificacion from './lic/ReqCodificacion.svelte';
import ReqPrecios from './lic/ReqPrecios.svelte';
import Explorer from "./lic/Explorer.svelte";
import IndexMaestras from "./lic/maestras/IndexMaestras.svelte";
import CargarMaestra from "./lic/maestras/CargarMaestra.svelte";
import ModalCanvas from "./lic/components/modals/ModalCanvas.svelte";
import ReqPlantillas from "./lic/ReqPlantillas.svelte";
import ItemMaestra from "./lic/ItemMaestra.svelte";
export default {
    Explorer,
    NauiDateRange,
    ReqGeneral,
    ReqFechas,
    ReqItems,
    ReqAsignacion,
    ReqCodificacion,
    ReqPrecios,
    ReqPlantillas,
    IndexMaestras,
    CargarMaestra,
    ItemMaestra,
    ModalCanvas
};
